import { Injectable } from "@angular/core";
import { Router } from "@angular/router";

import { from } from "rxjs";
import { exhaustMap, map, catchError, tap } from "rxjs/operators";
import { Store } from "@ngrx/store";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { AppState } from "../../reducers";
import * as TenantActionTypes from "../../actions/tenant/tenant.actions";
import * as MessagesActionTypes from "../../actions/messages/message.actions";

import { TranslateService } from "@ngx-translate/core";
import { TenantService } from "src/app/shared/services/tenant/tenant.service";

import { SnackBarUtils } from "src/app/shared/utils/snackbarUtils";
import { SnackbarType } from "src/app/models/snackbar/snackbar.model";
import * as LoginActionTypes from "../../actions/login/login.actions";

@Injectable()
export class TenantEffects {
  getCurrentTenant$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TenantActionTypes.getCurrentTenantFormatList),
      exhaustMap((action) =>
        this.tenantService.getTenants(action.pageReq).pipe(
          map((result) =>
            TenantActionTypes.loadCurrentTenantFormatList({ response: result })
          ),
          catchError((error) => {
            const actions = [
              TenantActionTypes.loadCurrentTenantFormatList({ response: [] }),
              MessagesActionTypes.setMessage({
                appMessage: {
                  key: "error",
                  message: this.translate.instant("Tenant.loadError"),
                  owner: "Tenant-Management",
                  severity: "error",
                  timestamp: new Date().getTime(),
                },
              }),
            ];
            return from(actions);
          })
        )
      )
    )
  );

updateCurrentTenant$ = createEffect(() =>
  this.actions$.pipe(
    ofType(TenantActionTypes.updateTenant),
    exhaustMap((action) =>
      this.tenantService.updateCurrentTenant(action.tenant).pipe(
        map(() => TenantActionTypes.getCurrentTenantFormatList({ pageReq: null })),
        tap(() => {
          this.store$.dispatch(
            MessagesActionTypes.setSnackbar(
              SnackBarUtils.setSnackBar(
                this.translate.instant("Tenant.tenantUpdated"),
                SnackbarType.SUCCESS
              )
            )
          );
          if (action.logoutAfterUpdate) {
            this.store$.dispatch(LoginActionTypes.logOut())
          }
        }),
        catchError(() => {
          return from([
            TenantActionTypes.setLoadingEndState(),
            MessagesActionTypes.setSnackbar(
              SnackBarUtils.setSnackBar(
                this.translate.instant("Tenant.errorUpdateTenant"),
                SnackbarType.ERROR
              )
            ),
          ]);
        })
      )
    )
  )
);

  getTenant$ = createEffect(() => 
    this.actions$.pipe(
      ofType(TenantActionTypes.getTenant),
      exhaustMap((action) => 
        this.tenantService.getTenant(action.code).pipe(
          map((result) => 
            TenantActionTypes.loadTenant({ result })
          ),
          catchError((error) => {
            const actions = [
              MessagesActionTypes.setMessage({
                appMessage: {
                  key: "error",
                  message: this.translate.instant("Tenant.loadError"),
                  owner: "Tenant-Management",
                  severity: "error",
                  timestamp: new Date().getTime(),
                },
              }),
            ];
            return from(actions);
          })
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private store$: Store<AppState>,
    private tenantService: TenantService,
    private router: Router,
    private translate: TranslateService
  ) {}
}
